import {
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import { Rule } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import { RichTextEditor } from "components/Editor/RichTextEditor";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useRef, useState } from "react";
import { ModalStatus } from "types/modal";
import { observer } from "mobx-react";
import { areaStore } from "store/areaStore";
import { Shop } from "types/shop";
import { shopApi } from "api/shop.api";
import { debounce } from "lodash";
import { Product } from "types/product";
import { productApi } from "api/product.api";
import { DefaultOptionType } from "antd/lib/select";
import { Popup, PopupType, PopupTypeTrans } from "types/popup";
import { popupApi } from "api/popup.api";
import { RichTextEditorV2 } from "components/Editor/RichTextEditorV2";

const rules: Rule[] = [{ required: true }];
const { Option } = Select;

interface PopupForm extends Popup {
  areaId: number;
  productId: number;
  shopId: number;
}

export const PopupModal = observer(
  ({
    visible,
    status,
    popup,
    onClose,
    onSubmitOk,
  }: {
    visible: boolean;
    status: ModalStatus;
    popup: Partial<Popup>;
    onClose: () => void;
    onSubmitOk: () => void;
  }) => {
    const [form] = Form.useForm<PopupForm>();
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState("");
    const [shops, setShops] = useState<DefaultOptionType[]>([]);
    const [products, setProducts] = useState<DefaultOptionType[]>([]);
    const [fetching, setFetching] = useState(false);
    const [formContentType, setFormContentType] = useState(PopupType.Content);
    const editorRef = useRef<{ setContent: (content: string) => void }>(null);

    useEffect(() => {
      fetchDataShop();
    }, []);

    useEffect(() => {
      if (status == "create" && visible) {
        form.resetFields();
      } else {
      }
      setContent(popup.content || "");
    }, [visible, status]);

    useEffect(() => {
      form.setFieldsValue({
        ...popup,
        areaId: popup.area?.id,
        productId: popup.product?.id,
        shopId: popup.shop?.id,
      });
      return () => {};
    }, [popup]);

    const fetchDataShop = async (search = "") => {
      setFetching(true);
      const res = await shopApi.findAll({ page: 1, limit: 20, search });
      setFetching(false);

      const dataShops: Shop[] = res.data.shops;
      const options = dataShops.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      setShops([{ value: 0, label: "Không chọn" }, ...options]);
    };

    const fetchDataProduct = async (search = "") => {
      const shopId = form.getFieldValue("shopId");
      const res = await productApi.findAll({
        page: 1,
        limit: 20,
        search,
        shopId,
      });

      const dataProducts: Product[] = res.data.products;
      const options = dataProducts.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      setProducts([{ value: 0, label: "Không chọn" }, ...options]);
    };

    const onShopChange = () => {
      form.setFieldsValue({ productId: 0 });
      fetchDataProduct("");
    };

    const onSearchShop = useRef(debounce(fetchDataShop, 500));

    const onSearchProduct = useRef(debounce(fetchDataProduct, 500));

    const createData = async () => {
      const valid = await form.validateFields();
      const data = {
        popup: {
          ...form.getFieldsValue(),
          content,
        },
        areaId: form.getFieldValue("areaId"),
        productId: form.getFieldValue("productId"),
        shopId: form.getFieldValue("shopId"),
      };

      setLoading(true);
      try {
        const res = await popupApi.create(data);
        message.success("Tạo mới thành công!");
        onClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    const updateData = async () => {
      const valid = await form.validateFields();
      console.log("form.getFieldsValue()", form.getFieldsValue());
      const data = {
        popup: {
          ...form.getFieldsValue(),
          content,
        },
        areaId: form.getFieldValue("areaId"),
        productId: form.getFieldValue("productId"),
        shopId: form.getFieldValue("shopId"),
      };

      setLoading(true);
      try {
        const res = await popupApi.update(popup?.id || 0, data);
        message.success("Cập nhật thành công");
        onClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    return (
      (<Modal
        onCancel={onClose}
        open={visible}
        title={status == "create" ? "Tạo mới popup" : "Cập nhật popup"}
        style={{ top: 20 }}
        width={1200}
        cancelText="Đóng"
        okText="Lưu"
        confirmLoading={loading}
        onOk={() => {
          status == "create" ? createData() : updateData();
        }}
      >
        <Form
          layout="vertical"
          initialValues={{ type: formContentType }}
          form={form}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Tiêu đề" name="title" rules={rules}>
                <Input placeholder="" />
              </Form.Item>

              {/* <Form.Item label="Khu vực" name="areaId">
                <Select style={{ width: "100%" }}>
                  <Option value={0}>Không chọn</Option>
                  {areaStore.list.map((e) => (
                    <Option key={e.id} value={e.id}>
                      {e.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item> */}

              <Form.Item shouldUpdate={true}>
                {() => {
                  return (
                    <Form.Item
                      label="Hình ảnh"
                      required
                      rules={rules}
                      name="image"
                    >
                      <SingleImageUpload
                        width={300}
                        height={150}
                        onUploadOk={(path: string) => {
                          console.log("onUploadOk:", path);
                          form.setFieldsValue({
                            image: path,
                          });
                        }}
                        imageUrl={form.getFieldValue("image")}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>

            <Col span={16}>
              <Form.Item label="Loại nội dung" name="type">
                <Radio.Group value={formContentType}>
                  {Object.values(PopupType).map((type) => (
                    <Radio key={type} value={type}>
                      {PopupTypeTrans[type]}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>

              <Form.Item shouldUpdate noStyle>
                {() => {
                  if (form.getFieldValue("type") == PopupType.Link) {
                    return (
                      <Form.Item rules={rules} label="Link" name="link">
                        <Input placeholder="" />
                      </Form.Item>
                    );
                  }
                  if (form.getFieldValue("type") == PopupType.Shop) {
                    return (
                      <Form.Item
                        rules={rules}
                        label="Doanh nghiệp"
                        name="shopId"
                      >
                        <Select
                          style={{ width: "100%" }}
                          onSearch={onSearchShop.current}
                          showSearch
                          notFoundContent={
                            fetching ? <Spin size="small" /> : null
                          }
                          options={shops}
                          filterOption={false}
                        />
                      </Form.Item>
                    );
                  }
                  if (form.getFieldValue("type") == PopupType.Product) {
                    return (
                      <>
                        <Form.Item
                          rules={rules}
                          label="Doanh nghiệp"
                          name="shopId"
                        >
                          <Select
                            style={{ width: "100%" }}
                            onSearch={onSearchShop.current}
                            showSearch
                            notFoundContent={
                              fetching ? <Spin size="small" /> : null
                            }
                            options={shops}
                            filterOption={false}
                            onChange={onShopChange}
                          />
                        </Form.Item>

                        <Form.Item
                          rules={rules}
                          label="Sản phẩm"
                          name="productId"
                        >
                          <Select
                            style={{ width: "100%" }}
                            onSearch={onSearchProduct.current}
                            showSearch
                            notFoundContent={
                              fetching ? <Spin size="small" /> : null
                            }
                            options={products}
                            filterOption={false}
                          />
                        </Form.Item>
                      </>
                    );
                  }
                  return (
                    <Form.Item required label="Nội dung" name="content">
                      <RichTextEditorV2
                        onChange={(content: string) => {
                          setContent(content);
                        }}
                        content={content}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>)
    );
  }
);
